import React from 'react';
import { UID } from 'react-uid';

const CheckIcon = ({
  title = 'Check',
  decorative = true,
  className,
  color,
  size,
}) => (
  <UID>
    {(uid) => (
      <div style={{ color, width: size, height: size }} className={className}>
        <svg
          role="img"
          aria-hidden={decorative}
          aria-labelledby={uid}
          width="100%"
          height="100%"
          viewBox="0 0 8 6"
        >
          <title id={uid}>{title}</title>
          <path
            fill="currentColor"
            d="M5.055 1.673l-2.181 2.22c.023-.024-1.215-1.546-1.3-1.633a.94.94 0 0 0-.652-.273.931.931 0 0 0-.652.273c-.16.178-.28.413-.27.664.012.25.095.484.27.664l1.844 1.883.256.26a.924.924 0 0 0 1.303 0l1.375-1.399 2.182-2.22.501-.51A.973.973 0 0 0 8 .938c0-.23-.1-.504-.269-.663C7.556.11 7.326-.011 7.079 0a.934.934 0 0 0-.649.274L5.055 1.673z"
            fillRule="evenodd"
          />
        </svg>
      </div>
    )}
  </UID>
);

export default CheckIcon;
